<template>
  <div>
    <el-form :model="form" ref="form" class="form-warp">
      <el-table :data="form.tableData">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="operate" label="操作" width="100" align="center">
          <template slot-scope="{ $index, row }">
            <el-link :underline="false" style="margin-right: 10px" @click="plus($index)">
              <i class="el-icon-add-group"></i>
            </el-link>
            <el-link :disabled="form.tableData.length <= 1" :underline="false" @click="minus($index)"><i class="el-icon-sub"></i></el-link>
          </template>
        </el-table-column>
        <el-table-column prop="imageUrl" width="60" label="图片">
          <template slot-scope="{ row }">
            <el-form-item style="padding: 6px">
              <ImgUpload
                :width="30"
                :height="30"
                :size="100"
                :file="row.imageUrl"
                :isSingle="true"
                @upload-success="url => handleUploaderChanged(row, url)"
                @del="() => handleUploaderChanged(row, '')"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <template v-for="col in tableCols">
          <el-table-column v-if="col.visible" :key="col.name" :prop="col.name" :label="col.label" :width="col.width">
            <template slot="header">
              <span v-if="col.required" style="color: red">*</span>{{ col.label }}
              <el-tooltip v-if="col.headerTip" effect="dark" :content="col.headerTip" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
              <span v-if="col.isBatchSet"><el-link :underline="false" @click="batchSet(col)">批量设置</el-link></span>
            </template>
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`tableData[${$index}].tableItem.${col.name}`" :rules="rules[col.name]">
                <el-select
                  v-if="['MULTICHECK', 'SINGLECHECK'].includes(col.type)"
                  clearable
                  v-model="row.tableItem[col.name]"
                  placeholder="请选择"
                  v-bind="col.props"
                >
                  <el-option v-for="item in optionsMap[col.name]" :key="item.value" :label="item.displayName" :value="item.value">
                  </el-option>
                </el-select>
                <el-input-digit
                  v-else-if="col.type === 'number'"
                  v-model.number="row.tableItem[col.name]"
                  :nullable="true"
                  v-bind="col.props"
                />
                <el-input
                  v-else-if="col.type === 'INPUT'"
                  v-model="row.tableItem[col.name]"
                  v-bind="col.props"
                  @click="oneClick(col, $index)"
                >
                </el-input>
                <span v-else>{{ row.tableItem[col.name] }}</span>
              </el-form-item>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-button type="link" @click="addTable">+ 添加更多 (当前数量:{{ form.tableData.length }})</el-button>
    </el-form>
    <el-dialog title="批量设置" :visible.sync="dialogBatchVisible">
      <el-form>
        <!-- <el-form-item v-if="batchCol.label === '规格型号'">
          请选择规则 ：<el-radio v-model="batchVal">扩展属性组合</el-radio>
        </el-form-item> -->
        <el-form-item :label="`请输入所有型号统一的${batchCol.label}：`">
          <el-select
            v-if="['MULTICHECK', 'SINGLECHECK'].includes(batchCol.type)"
            clearable
            v-model="batchVal"
            placeholder="请选择"
            v-bind="batchCol.props"
          >
            <el-option v-for="item in optionsMap[batchCol.name]" :key="item.value" :label="item.displayName" :value="item.value">
            </el-option>
          </el-select>
          <el-input-digit v-else-if="batchCol.type === 'number'" v-model.number="batchVal" :nullable="true" v-bind="batchCol.props" />
          <el-input v-else-if="batchCol.type === 'INPUT'" v-model="batchVal" v-bind="batchCol.props"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBatchVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchDialiogSure">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <GenSkuOuterIdDialog ref="genSkuOuterIdDialog" /> -->
    <!-- 商品编码映射 -->
    <ProductMappingDialog ref="productMappingDialog" :baseItemId="alibabaForm.baseItemId"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import ProductMappingDialog from '@/components/prod/center/dialogs/ProductMappingDialog.vue';
import GenSkuOuterIdDialog from '@/components/prod/center/dialogs/GenSkuOuterIdDialog.vue';

import storeMixins from '../store-mixins';
import { cloneDeep } from 'lodash';
export default {
  mixins: [storeMixins],
  components: {
    ImgUpload,
    GenSkuOuterIdDialog,
    ProductMappingDialog,
  },
  props: ['props'],
  data() {
    return {
      form: {
        tableData: [],
      },
      rules: {},
      tableCols: [],
      optionsMap: {},
      dialogBatchVisible: false,
      batchVal: '',
      batchCol: {},
    };
  },
  computed: {},
  watch: {
    props: {
      handler(v) {
        const porpsChildren = v.dataSource.children || [];
        const tableCols = [
          {
            name: 'skuOuterId',
            label: '商家编码',
            type: 'INPUT',
            required: true,
            visible: true,
            isBatchSet: true,
            width: '140px',
            props: { readonly: true },
          },
          { name: 'skuPrice', label: '单价', type: 'number', visible: true, isBatchSet: true, props: { precision: 3, clearable: true } },
          {
            name: 'skuStock',
            label: '可售数量',
            type: 'number',
            visible: true,
            isBatchSet: true,
            props: { precision: 0, clearable: true },
          },
        ];
        this.$set(this.rules, 'skuOuterId', [{ required: true, message: '必填' }]);
        porpsChildren.forEach(item => {
          let { name, label, options, _oriRules, rules, type } = item;
          if (name.startsWith('p-')) {
            const { customizable, maxLengthRule, required, readOnlyRule, visible } = _oriRules || {};
            let col = {
              name,
              label,
              type,
              customizable,
              isBatchSet: true,
              required: required === 'true',
              visible: visible === 'true',
              width: '120px',
              isExtend: true,
              props: {
                multiple: type === 'MULTICHECK',
                filterable: true,
                'allow-create': customizable === 'true',
                disabled: readOnlyRule === 'true',
                maxlength: maxLengthRule ? Number(maxLengthRule) : '',
              },
            };
            this.$set(this.optionsMap, name, options || []);
            this.setRules(name, cloneDeep(rules), label);
            tableCols.push(col);
          }
        });
        this.tableCols = tableCols;
        this.initTableData();
      },
      immediate: true,
      deep: true,
    },
    'form.tableData': {
      handler(v) {
        const xhCol = this.tableCols.find(col => col.label === '规格型号') || {};
        const xhList = v.map(item => item.tableItem[xhCol.name]).filter(Boolean)
        this.updateAlibabaForm({salePropTableXhList: xhList})
      },
      deep: true,
      immediate: true
    }

  },
  methods: {
    setRules(name, rules, label) {
      if (label == '规格型号') {
        rules.push({
          validator: (rule, value, callback) => {
            const xinghaoList = this.form.tableData
              .map(row => {
                return row.tableItem[name];
              })
              .filter(Boolean);
            const someValLength = xinghaoList.filter(v => v === value).length;
            if (someValLength > 1) {
              callback(new Error('规格型号不能重复'));
            } else {
              callback();
            }
          },
        });
      }
      this.$set(this.rules, name, rules);
    },
    plus($index) {
      this.form.tableData.splice($index + 1, 0, this.getAddItem());
    },
    minus($index) {
      this.form.tableData.splice($index, 1);
    },
    addTable() {
      this.form.tableData.push(this.getAddItem());
    },
    batchSet(col) {
      if (col.name === 'skuOuterId') {
        this.handleProductMapping(-1);
      } else {
        this.dialogBatchVisible = true;
        this.batchCol = col;
        this.batchVal = '';
        // this.batchVal = col.label === '规格型号' ? true : '';
      }
    },
    batchDialiogSure() {
      this.form.tableData.forEach(row => {
        let batchVal = this.batchVal;
        row.tableItem[this.batchCol.name] = batchVal;
      });
      this.dialogBatchVisible = false;
    },
    handleUploaderChanged(row, url) {
      row.imageUrl = url;
    },
    method_getData() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            const tableData = cloneDeep(this.form.tableData);
            const skuList = tableData.map(row => {
              const tableItem = row.tableItem;
              row.skuFieldDescriptorList = row.skuFieldDescriptorList || [];
              row.skuFieldDescriptorList.forEach(skuField => {
                skuField.defaultValue = tableItem[skuField.name];
              });
              const xhCol = this.tableCols.find(col => col.label === '规格型号') || {};
              const extendValues = {};
              this.tableCols
                .filter(col => col.isExtend)
                .map(col => {
                  extendValues[col.name] = {
                    nameKey: col.name,
                    name: col.label,
                    value: tableItem[col.name],
                  };
                });
              row.industrySkuSpecifications[0] = {
                ...row.industrySkuSpecifications[0],
                checked: true,
                name: '规格型号',
                nameKey: xhCol.name,
                value: tableItem[xhCol.name],
              };
              row.industrySkuSpecifications[1] = {
                ...row.industrySkuSpecifications[1],
                checked: true,
                name: '规格参数',
                nameKey: '规格参数',
                extendValues,
              };
              delete row.tableItem;
              return row;
            });
            resolve(skuList);
          } else {
            // 验证不通过的逻辑
            console.log('验证不通过，请检查输入');
            resolve(false);
            return false;
          }
        });
      });
    },
    getAddItem() {
      let defaultItem = cloneDeep(this.form.tableData[0]);
      const tableItem = {};
      Object.keys(defaultItem.tableItem).map(name => {
        tableItem[name] = '';
      });
      defaultItem = {
        ...defaultItem,
        id: null,
        imageUrl: '',
        tableItem,
      };
      return defaultItem;
    },
    initTableData() {
      const skuList = cloneDeep(this.alibabaForm.skuList) || [];
      const tableData = [];
      skuList.forEach(sku => {
        const { industrySkuSpecifications, skuFieldDescriptorList } = sku;
        let tableItem = {};
        this.tableCols.forEach(col => {
          tableItem[col.name] = '';
        });

        (skuFieldDescriptorList || []).forEach(skuField => {
          tableItem[skuField.name] = skuField.defaultValue;
        });
        industrySkuSpecifications.forEach(skuSpec => {
          const { nameKey, value, extendValues } = skuSpec;
          if (nameKey) {
            tableItem[nameKey] = value;
          }
          if (extendValues) {
            Object.values(extendValues).forEach(({ nameKey, value }) => {
              tableItem[nameKey] = value;
            });
          }
        });
        sku.tableItem = tableItem;
        tableData.push(sku);
      });
      this.$set(this.form, 'tableData', tableData);
      this.$nextTick(() => {
        this.$refs.form?.validate();
      })
    },
    oneClick(col, $index) {
      if (col.name === 'skuOuterId') {
        this.handleProductMapping($index);
      }
    },
    handleProductMapping(skuIndex) {
      this.$refs.productMappingDialog.handleShow({
        onSuccess: (selectRowData) => {
          const { skuOuterId, id } = selectRowData;
          this.form.tableData.forEach((item, idx) => {
            if (this.operateSkuIndex == -1 || idx === this.operateSkuIndex) {
              (item.baseSkuId = id), (item.skuOuterId = skuOuterId), (item.tableItem.skuOuterId = skuOuterId);
            }
          });
        }
      });
      this.operateSkuIndex = skuIndex;
    },
  },
  mounted() {},
};
</script>
  
<style lang="scss" scoped>
.form-warp {
  ::v-deep .el-form-item__error {
    position: unset;
  }
}
</style>